/**
 * Initial focus of the create and edit shift dialogs (#2119). Radix focuses the first
 * focusable element, which is the help icon next to the "Employee" label; its tooltip then
 * covered the top of the form on every open. The employee field takes the focus instead.
 */
export function focusFirstShiftField(event: Event): void {
  const container = event.currentTarget instanceof HTMLElement ? event.currentTarget : null;
  const field = container?.querySelector<HTMLElement>('#employee-select');
  if (!field) return;
  event.preventDefault();
  field.focus();
}
